import {
  LOAD_PRODUCT,
  LOAD_PRODUCT_ERROR,
  LOAD_PRODUCT_SUCCESS,
} from '../constants/product';

const PRODUCT_INIT = {
  product: {},
  loading: true,
  loadingError: false,
};

export default (state = PRODUCT_INIT, action) => {
  switch (action.type) {
    case LOAD_PRODUCT:
      return {
        ...state,
        loading: true,
        loadingError: false,
      };
    case LOAD_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        loadingError: false,
        product: action.payload,
      };
    case LOAD_PRODUCT_ERROR:
      return {
        ...state,
        product: {},
        loading: false,
        loadingError: true,
      };
    default:
      return state;
  }
};
